import type { Booking } from '@ngb-frontend/shared/types'

export const getRPVTypeFromBooking = (booking: Booking) => ({
  rental: booking.replacement_mobility === 'RentalByExternalCompany',
  courtesy: booking.replacement_mobility === 'Courtesy',
})
